<template>
    <div class="loading-overlay">
        <LoadAnimation />
        <p class="loading-text text-white">
            Updating YHub<span class="animation"></span>
        </p>
    </div>
</template>

<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.loading-text {
    margin-top: 20px;
    font-size: 18px;
}

.animation {
    position: relative;
    width: 20px; /* Set a fixed width */
    display: inline-block; /* Ensure the width applies */
}

.animation::before {
    content: ".";
    animation: dots 1s infinite linear;
}

@keyframes dots {
    0% {
        content: ".";
    }
    33% {
        content: "..";
    }
    66% {
        content: "...";
    }
    100% {
        content: ".";
    }
}
</style>

<script>
import LoadAnimation from "@components/LoadAnimation.vue";

export default {
    name: "UpdateApp",
    components: { LoadAnimation },
};
</script>
